import React, { useMemo } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import useMediaQuery from '@mui/material/useMediaQuery';

function normalizeCenter(center) {
    if (!center) return null;
    if (Array.isArray(center) && center.length === 2) {
        return { lat: Number(center[0]), lng: Number(center[1]) };
    }
    if ('latitude' in center && 'longitude' in center) {
        return { lat: Number(center.latitude), lng: Number(center.longitude) };
    }
    if ('lat' in center && 'lng' in center) {
        return { lat: Number(center.lat), lng: Number(center.lng) };
    }
    return null;
}

export default function Map({ center, zoom = 14 }) {
    const isMobile = useMediaQuery('(max-width:600px)');

    // Read API key from env (CRA: REACT_APP_*, Vite: VITE_*)
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: apiKey
    });

    const containerStyle = useMemo(
        () => ({
            width: '100%',
            height: isMobile ? '300px' : '500px',
            margin: 'auto'
        }),
        [isMobile]
    );

    const centerNormalized = useMemo(() => normalizeCenter(center), [center]);
    const zoomNum = Number.isFinite(Number(zoom)) ? Number(zoom) : 14;

    if (!isLoaded || !centerNormalized) return null;

    return (
        <GoogleMap mapContainerStyle={containerStyle} center={centerNormalized} zoom={zoomNum}>
            <Marker position={centerNormalized} />
        </GoogleMap>
    );
}